import { ConditionBase, ConditionBuilder } from '../condition.type';

export interface ConditionMax extends ConditionBase {
  /**
   * The value of the related field must be smaller than or equal to
   * this value for the condition to be fulfilled.
   */
  readonly max: number;
  /**
   * If `true` uses 'less than'
   * otherwise uses 'less than or equal to'
   *
   * @default false
   */
  readonly exclusive?: boolean;
}

/**
 * Type guard that checks if an object fulfills the `ConditionMax` interface
 *
 * @param c Non nullish object
 * @returns `true` if `c` satisfies `ConditionMax`
 */
export const isConditionMax = (c: Record<string, any>): c is ConditionMax =>
  'max' in c && typeof c['max'] === 'number';

/**
 * @param condition Condition object
 *
 * @returns
 * Condition function that returns `true` if the value is
 * less or equal the definied maximum value, otherwise `false`.
 */
export const max: ConditionBuilder<ConditionMax, number> = (condition) => {
  const { max: maxValue, exclusive = false } = condition;

  return exclusive
    ? // less than
      (value) => value < maxValue
    : // less than or equal to
      (value) => value <= maxValue;
};
